import {
  createContext,
  ReactNode,
  useContext,
  useState
} from "react";
import {useNavigationType} from "react-router-dom";

const HistoryInfoContext = createContext({canGoBack: false, canGoForward: false});


export function NonokiHistoryInfoProvider(props: {children: ReactNode}) {
  const navigationType = useNavigationType();
  const [lastIndex, setLastIndex] = useState(() => {
    if ("idx" in window.history.state) {
      return window.history.state.idx;
    }

    return 0;
  });

  if (navigationType === "PUSH" && lastIndex !== window.history.state?.idx) {
    setLastIndex(window.history.state.idx);
  }

  const data = {
    canGoForward: window.history.state?.idx < lastIndex,
    canGoBack: window.history.state?.idx > 0,
  }

  return (
    <HistoryInfoContext.Provider value={data}>
      {props.children}
    </HistoryInfoContext.Provider>
  );
}


export function useNonokiHistoryInfo() {
  return useContext(HistoryInfoContext);
}
